export default __webpack_public_path__ + "static/media/patrick.4f6bae0a.jpeg";